module.exports = __webpack_public_path__ + "static/media/foto4.d73f4c03.png";